import React from 'react';
import {
  Box,
  CloseIcon,
  HorizontalDivider,
  theme,
  TransparentButton,
  Typography,
  WarningIcon,
} from '@ttx/design-system';

interface DynamicContentModalProps {
  onClose: () => void;
}

export const DynamicContentModal: React.FC<DynamicContentModalProps> = ({
  onClose,
}: DynamicContentModalProps) => {
  return (
    <Box
      w="100%"
      maxWidth={588}
      minWidth={['inherit', 588]}
      borderColor="outlines"
      borderWidth="one"
      borderStyle="solid"
    >
      <Box
        paddingX="md"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box flexDirection="row" alignItems="center">
          <WarningIcon size={12} />
          <Box ml="two">
            <Typography color="textDefault" textStyle="s">
              Airdrop Only
            </Typography>
          </Box>
        </Box>
        <TransparentButton onPress={onClose} style={{padding: theme.space.md}}>
          <CloseIcon size={18} />
        </TransparentButton>
      </Box>
      <HorizontalDivider />
      <Box paddingX="md" paddingY="lg">
        <Typography textStyle="s" color="textDefault">
          You cannot purchase this collectible; it is exclusive to Rosa&apos;s
          top 25 fans. DM her to qualify
        </Typography>
        <Box mt="md" />
      </Box>
      <HorizontalDivider />
      <TransparentButton onPress={onClose}>
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          paddingY="s"
        >
          <Typography textStyle="s" color="textDefault">
            Got it
          </Typography>
        </Box>
      </TransparentButton>
    </Box>
  );
};
